import React from "react";
import {Route, Switch} from "react-router";
import HelpVideosGallery from "./HelpVideosGallery";
import {useSubscription} from "../subscription/useSubscription";
import HelpVideoPlayer from "./HelpVideoPlayer";

const HelpVideos = ({}) => {
    useSubscription("HELP_VIDEOS", "/ui/api/helpvideos", 60);

    return (
        <Switch>
            <Route exact path="/help/video/:videoId">
                <HelpVideoPlayer/>
            </Route>

            <Route>
                <HelpVideosGallery/>
            </Route>
        </Switch>
    )
}

export default HelpVideos
